/* Library */
import React, { Component } from 'react';
// import _ from 'lodash';
import CheckBox from '../../../../../../components/ZUILib/CheckBox';
import InputButton from '../../../../../../components/ZUILib/InputButton';
// import commonUtil from '../../../../../../utils/commonUtil';
// import Warning from '../../../../../../components/Warning';

class GiftPreferencesWap extends Component {

  constructor() {
    super();
    this.showAddressWithPreference = this.showAddressWithPreference.bind(this);
    this.changeAddressPreferenceWap = this.changeAddressPreferenceWap.bind(this);
    this.getUpdatedData = this.getUpdatedData.bind(this);
    this.addChildControlRef = this.addChildControlRef.bind(this);
    this.addressDetails = [];
    this.updatedData = '';
    this.selectedNewPreferenceOfDelivery = [];
    this.gotUpdated = true;
    this.isRenderedOnce = false;
    this.pageLoad = true;
    this.state = {
      displayStyle: 'none',
    };
  }

  // componentDidMount() {
  //   this.eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
  //   if (this.eventID) {
  //     this.props.preferredDeliveryDayDetails(this.eventID, 'true');
  //   }
  // }
  showAddressWithPreference(data) {
    const eventID = this.props.params && this.props.params.eventID ? this.props.params.eventID : null;
    if (!data.checked) {
      this.props.preferredDeliveryDayDetails(eventID, 'false');
      this.setState({ displayStyle: 'none' });
    }
    if (data.checked) {
      this.props.preferredDeliveryDayDetails(eventID, 'true');
      this.setState({ displayStyle: 'block' });
      this.pageLoad = true;
    }
  }
  changeAddressPreferenceWap = (selectedData, checkedOption) => {
    const tempOldDeliveryPreference = JSON.parse(JSON.stringify(this.selectedNewPreferenceOfDelivery));
    tempOldDeliveryPreference.forEach((add) => {
      if (selectedData.addressId === add.addressId) {
        add.days.forEach((day) => {
          const newDay = day;
          if (day.deliveryDay === checkedOption.value) {
            newDay.opted = checkedOption.checked;
          }
        });
      }
    });
    this.selectedNewPreferenceOfDelivery = tempOldDeliveryPreference;
    const saveBtn = document.querySelector('#Guardar');
    saveBtn.style.display = 'block';
  }

  addChildControlRef(childControl) {
    if (childControl === null) {
      return;
    }
    this.addressDetails.push(childControl);
  }

  getUpdatedData() {
    this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo.forEach((address, index) => {
      if (this.addressDetails[index] && this.addressDetails[index].firstName && (this.addressDetails[index].firstName === address.firstName)) {
        this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo[index] = this.addressDetails[index];
      }
    });
    return this.props.deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo;
  }

  offset = (el) => {
    const rect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return ({ top: rect.top + scrollTop, left: rect.width + scrollLeft });
  }

  move = (elem, leftOffset, movementType) => {
    const ele = elem;
    if (movementType === 'show') {
      let left = leftOffset;
      const id = setInterval(() => {
        left -= 10;  // update parameters
         // show frame
        // check finish condition
        if (left < 0) {
          left = 0;
        }
        ele.style.left = left + 'px';
        if (left <= 0) {
          clearInterval(id);
        }
      }, 0.01); // draw every 10ms
    } else if (movementType === 'hide') {
      let left = 0;
      const id = setInterval(() => {
        left += 10;  // update parameters
        ele.style.left = left + 'px'; // show frame
        // check finish condition
        if (left >= leftOffset) {
          clearInterval(id);
        }
      }, 0.01); // draw every 10ms
    }
  }

  hideDeliveryDay = () => {
    const menu = document.querySelector('.deliveryAddressDetail');
    const offset = this.offset(menu);
    this.move(menu, offset.left, 'hide');
    menu.style.height = window.innerHeight;
    menu.style.overflowY = window.innerHeight;
    menu.style.overflowX = window.innerWidth;
    menu.classList.remove('visibleContent');
  }

  showDeliveryDay = (address) => {
    const menu = document.querySelector('.deliveryAddressDetail');
    this.props._showSelectedAddress(address);
    const offset = this.offset(menu);
    this.move(menu, offset.left, 'show');
    menu.style.height = window.innerHeight;
    menu.style.overflowY = window.innerHeight;
    menu.style.overflowX = window.innerWidth;
    menu.style.opacity = 1;
    menu.className += ' visibleContent';
  }

  // Lunes martes Miércoles Jueves Viernes Sábado Domingo
  getDays = (days) => {
    const weekDays = [{
      key: 'Lunes',
      value: 'Lu',
    },
    {
      key: 'Martes',
      value: 'Ma',
    },
    {
      key: 'Miércoles',
      value: 'Mi',
    },
    {
      key: 'Jueves',
      value: 'Ju',
    },
    {
      key: 'Viernes',
      value: 'Ve',
    },
    {
      key: 'Sábado',
      value: 'Sá',
    },
    {
      key: 'Domingo',
      value: 'Do',
    }];
    const actualDays = [];
    /* eslint-disable*/
    for (const myday of days) {
      for (const day of weekDays) {
        if (myday.opted.toString() === 'true' && (myday.deliveryDay).toUpperCase() === (day.key).toUpperCase()) {
          actualDays.push(day.value);
          break;
        }
      }
    }
    /* eslint-enable */
    return actualDays;
  }
  // componentDidMount() {
  //   if (this.props.deliveryDayAndAddressInfo) {
  //     this.props.deliveryDayAndAddressInfo.map((deliveryData) => {
  //       deliveryData.delieveryDaysInfo.map((data) => {
  //         if (data.opted === true) {
  //           this.forchk.style.display = 'block';
  //           this.chk.setChecked(true);
  //         }
  //         // else {
  //         //   this.forchk.style.display = 'none';
  //         // }
  //         return false;
  //       }); return false;
  //     });
  //   }
  // }
  handleDeliveryPreferenceCheck = (deliveryDayAndAddressInfo) => {
    if (deliveryDayAndAddressInfo) {
      const selectedDays = [];
      deliveryDayAndAddressInfo.map((info) => {
        const days = info.delieveryDaysInfo.filter(day => day.opted === true);
        return selectedDays.push(days);
      });

      if (selectedDays.length > 0 && selectedDays[0].length > 0) {
        this.setState({ displayStyle: 'block' });
        this.chk.setChecked(true);
      } else if (!this.pageLoad) {
        this.setState({ displayStyle: 'none' });
        this.chk.setChecked(false);
      }
    } else {
      this.setState({ displayStyle: 'none' });
      this.chk.setChecked(false);
    }
  }

  componentWillReceiveProps(nextprops) {
    if ((nextprops.deliveryDayAndAddressInfo && nextprops.deliveryDayAndAddressInfo.deliveryDayAndAddressInfo.length > 0) || (!this.pageLoad && nextprops.deliveryDayAndAddressInfo === null && nextprops.deliveryDayPreference && nextprops.deliveryDayPreference.status && nextprops.deliveryDayPreference.status.status === 'success')) {
      this.handleDeliveryPreferenceCheck((nextprops.deliveryDayAndAddressInfo && nextprops.deliveryDayAndAddressInfo.deliveryDayAndAddressInfo) || null);
    }
  }
  waphandleSumbitChangedAddressPreference = (selectedNewPreferenceOfDelivery) => {
    this.props.waphandleSumbitChangedAddressPreference(selectedNewPreferenceOfDelivery);
    this.pageLoad = false;
  }

  render() {
    const { deliveryDayPreference, selectedAddressForChangePreference } = this.props;
    const eventStatusForSuspended = this.props.eventStatusForSuspended;

    const style = {
      left: window.innerWidth + 'px',
      top: '0',
      position: 'absolute',
      background: '#fff',
      minHeight: '100%',
      opacity: '0',
      width: '100%',
      zIndex: '100',
    };
    const saveButton = {
      name: 'Guardar',
      type: 'button',
      value: 'Guardar',
      id: 'Guardar',
      style: 'btnPrimaryAction',
      onClickHandler: () => { this.hideDeliveryDay(); this.waphandleSumbitChangedAddressPreference(this.selectedNewPreferenceOfDelivery); },
    };


    let displayStyle = this.state.displayStyle;
    let deliveryDayAndAddressInfo;
    if (deliveryDayPreference && deliveryDayPreference.preferredDeliveryDayDetails && deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo) {
      deliveryDayAndAddressInfo = JSON.parse(JSON.stringify(deliveryDayPreference.preferredDeliveryDayDetails.deliveryDayAndAddressInfo));

      if (!this.isRenderedOnce && deliveryDayAndAddressInfo) {
        deliveryDayAndAddressInfo.forEach((add) => {
          this.selectedNewPreferenceOfDelivery.push({
            addressId: add.addressId,
            days: add.delieveryDaysInfo,
          });
        });
        this.isRenderedOnce = true;
      }

      if (deliveryDayAndAddressInfo) {
        deliveryDayAndAddressInfo.map((deliveryData) => {
          deliveryData.delieveryDaysInfo.map((data) => {
            if (data.opted === true) {
              displayStyle = 'block';
            } return false;
          }); return false;
        });
      }
    }
    return (
      <div>
        {/* SecondStep */}
        <div className="container deliveryAddressDetail selectDeliveryDay" style={style}>
          <div className="row boxHeader">
            <div className="col-xs-12">
              <h2>Entrega por día de la semana</h2><span className="close" onClick={this.hideDeliveryDay}>Cerrar <i className="icon-tache2" /></span>
            </div>
          </div>
          <div className="row boxContent">
            {selectedAddressForChangePreference ?
              <div className="col-xs-12">
                <h2>{selectedAddressForChangePreference.nickName}</h2><span className="addressAdmin">{selectedAddressForChangePreference.firstName} {selectedAddressForChangePreference.lastName}</span>
                <address>{selectedAddressForChangePreference.firstName} {selectedAddressForChangePreference.lastName}, Ext. {selectedAddressForChangePreference.extNo}, Int. s/n, {selectedAddressForChangePreference.colony}, {selectedAddressForChangePreference.state}, Alvaro Obregón, C.P.{selectedAddressForChangePreference.postalCode}, {selectedAddressForChangePreference.country}, {selectedAddressForChangePreference.city}</address>
                {/* <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} /> */}
                <ul className="selectDayList">
                  <form>
                    {selectedAddressForChangePreference.delieveryDaysInfo.length > 0 ? selectedAddressForChangePreference.delieveryDaysInfo.map((currentAddress, index) =>
                      <li>
                        <CheckBox
                          changeOnPropsChange="true"
                          key={currentAddress.deliveryDay + index}
                          id={currentAddress.deliveryDay + '_' + selectedAddressForChangePreference.addressId}
                          defaultChecked={currentAddress.opted}
                          value={currentAddress.deliveryDay}
                          displayName={currentAddress.deliveryDay}
                          getSelectedValue={option => this.changeAddressPreferenceWap(selectedAddressForChangePreference, option)}
                          ref={(el) => { this.addChildControlRef(el); }}
                          disabled={this.props.eventStatusForSuspended && 'disabled'}
                        />
                      </li>) : <span>{selectedAddressForChangePreference.message}</span>}
                  </form>
                </ul>
              </div> :
                null}
          </div>
          <div className="row boxButtons">
            <div className="col-xs-12" >
              <InputButton className="btnPrimaryAction" buttonAttr={saveButton} />
            </div>
          </div>
        </div>

        {/*  FirstStep */}
        <div className="myEventContent">
          <div className="col-xs-12">
            <div className="row">
              <h1 className="noBorder">Preferencias de entrega de regalos</h1>
              <p className="giftPreferenceIntro">Ponemos a tu disposición diferentes opciones para la entrega de tus regalos. Tu selección afectará directamente la entrega de todos tus regalos.</p>
            </div>
          </div>
          <div className="col-xs-12">
            <div className="giftPreference">
              <div className="checkbox">
                <CheckBox
                  id="showAddress"
                  displayName="¿Deseas asignar días de entrega?"
                  getSelectedValue={this.showAddressWithPreference}
                  ref={chk => this.chk = chk}
                  checked={displayStyle === 'block' ? 'checked' : ''}
                  disabled={eventStatusForSuspended === true ? 'disabled' : null}
                />
              </div>
            </div>
            {deliveryDayAndAddressInfo &&
            <div className="giftPreferenceAddress" style={{ display: displayStyle }} ref={forchk => this.forchk = forchk}>
              <p>Selecciona los días que deseas recibir tus regalos por cada una de tus direcciones</p>
              {deliveryDayAndAddressInfo.map((address, i) =>
                <div key={i} className="giftPA" onClick={() => { this.showDeliveryDay(address); }}>
                  <div>
                    <p className="giftPAName">{address.nickName}</p>
                    <p className="giftPAAdmin">{address.firstName} {address.lastName}</p>
                    <span className="days">Días de entrega.
                        {this.getDays(address.delieveryDaysInfo).map((day, index) => {
                          if (index !== (this.getDays(address.delieveryDaysInfo).length - 1)) {
                            return day + ', ';
                          } return day;
                        })}
                    </span>
                  </div>
                  <div><i className="icon-flecha_lightsvg_derecha" /></div>
                </div>)}
            </div>}
          </div>
        </div>
      </div>
    );
  }
    // return null;
  // }
}
export default GiftPreferencesWap;
